import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

// this function prevent keyboard characters like  e, + , - to be passed on the input
var onKeyPress = function onKeyPress(event) {
  var keyCode = event.keyCode || event.which;
  var keyValue = String.fromCharCode(keyCode);
  if (/\+|-|e/.test(keyValue)) event.preventDefault();
};

var isAmountValid = function isAmountValid(input) {
  var reg = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g;
  var isValid = input * 1 >= 1 && input * 1 <= 5000 && reg.test(input);
  return isValid;
};

var getUrlParameter = function getUrlParameter(name) {
  var text = name.replace(/\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(text, "=([^&#]*)"));
  var results = regex.exec(window.location.search);
  var param = results === null ? 'generic' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  return param;
};

var isInputMatchBoxValue = function isInputMatchBoxValue(moneyBoxes, selectMoneyBuy, setAmountDonate, input) {
  var inputToNum = input * 1;
  return Object.keys(moneyBoxes).map(function (box) {
    return moneyBoxes[box].value === inputToNum && (selectMoneyBuy(moneyBoxes[box].description, moneyBoxes[box].value), setAmountDonate(input));
  });
}; // This function is still in progress


var handleDonateSubmission = function handleDonateSubmission(amount, clientID, cartID, mbshipID, donateLink) {
  var givingType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'monthly';
  var currentpageUrl = window.location.href;
  var affiliateValue = getUrlParameter(currentpageUrl);
  var reg = /[#?|[\]\\]/g;

  if (currentpageUrl.match(reg) !== null) {
    var thisMatch = currentpageUrl.match(reg)[0];
    currentpageUrl = currentpageUrl.substring(0, currentpageUrl.indexOf(thisMatch));
  }

  var givingTypeUrl = givingType === 'single' ? 'single' : 'monthly';
  window.location.href = "".concat(donateLink, "?clientOverride=").concat(clientID, "&amount=").concat(amount, "&currency=GBP&givingType=").concat(givingTypeUrl, "&cartId=").concat(cartID, "&affiliate=").concat(affiliateValue, "&siteurl=").concat(currentpageUrl, "&rowID=").concat(mbshipID);
};

export { onKeyPress, isAmountValid, isInputMatchBoxValue, handleDonateSubmission };